<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="intro-dedication-text">In loving memory of my mother Paula Lee Wilcox</p>
<p class="flush-left ParaOverride-1"><span class="CharOverride-6">September 2, 1952–September 7, 2006</span></p>
<p class="image"><img alt="My Mother" class="_idGenPageitem-8" src="image/Image1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781630472863_EPUB-2.vue?4750b670